import React, { useEffect, useState } from 'react';
import { api } from '@/api/client';
export default function Timbrature(){
  const [rows,setRows]=useState<any[]>([]);
  const [dateISO,setDateISO]=useState(()=>new Date().toISOString().slice(0,10));
  useEffect(()=>{ api.get('/Punches/GetPunches',{ params:{ ADATE: dateISO }}).then(({data})=>setRows(data?.Punches||[])); },[dateISO]);
  return (<div><h2>Timbrature</h2><input type="date" value={dateISO} onChange={(e)=>setDateISO(e.target.value)} />{rows.map((r,i)=>(<div key={i}>{r.caption} — {new Date(r.punchTime).toLocaleString('it-IT')}</div>))}</div>);
}
